import { render, staticRenderFns } from "./deanPopUpNotification.vue?vue&type=template&id=1bc864b8&scoped=true"
import script from "./deanPopUpNotification.vue?vue&type=script&lang=ts"
export * from "./deanPopUpNotification.vue?vue&type=script&lang=ts"
import style0 from "./deanPopUpNotification.vue?vue&type=style&index=0&id=1bc864b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc864b8",
  null
  
)

export default component.exports